import React, { useState, useEffect } from 'react';
import './Staking.css';
import sampleImage from '../../assets/rocket.png'; // Replace with your image path
import Modal from '../Modal';
import { parseEther, formatUnits } from 'ethers';
import { stakeAddress } from '../../utils/contractAddress';

const Staking = ({sContract, tContract}) => {
  const [selectedView, setSelectedView] = useState('view1');
  const [stakeAmount, setStakeAmount] = useState("");
  const [deposits, setDeposits] = useState([]);
  const [nextWithdraw, setNextWithdraw] = useState(0);
  const [totalStaked, setTotalStaked] = useState(0);
  const [claimedRewards, setClaimed] = useState(0);
  const [availableToClaim, setAvailable] = useState(0);

  const [currentApy, setApy] = useState(0);

  const [modalOpen, setModalOpen] = useState(false);
    const [modalProps, setModalProps] = useState({
      title: '',
      message: '',
      txHash: '',
      error: '',
      isLoading: false,
    });

  
    const closeModal = () => {
      setModalOpen(false);
      setModalProps({
        title: '',
        message: '',
        txHash: '',
        error: '',
        isLoading: false,
      });
    };

  useEffect(() => {
    if(sContract){
      getData();
    }
  },[sContract])

  const getData = async() => {
    try {
      const apy = await sContract.APY();
      const deps = await sContract.myDeposits();
      const day = await sContract.day();

      let staked = 0;
      let earned = 0;
      let time = 0;
      let currentTime = new Date().getTime();
      let avail = 0;

      if(deps.length > 0) {
        const nextW = (Number(deps[deps.length-1][3]) + Number(day) * 30) * 1000;
        const available = formatUnits(await sContract.retrieveRewards());
        avail = available;
        if(nextW > currentTime) {
            time = nextW;
            deps.map((dep, index) => {
            earned += Number(formatUnits(dep[4]));
            staked += Number(formatUnits(dep[0]));
            })
          }
      }

      

      setClaimed(earned.toFixed(3));
      setAvailable(Number(avail).toFixed(3));
      setTotalStaked(staked);
      setNextWithdraw(time);
      setDeposits(deps);
      setApy(Number(apy) / 100);
    } catch (error) {
      
    }
  }

  const stake = async() => {
    try {
      setModalOpen(true);
      setModalProps({
        title: 'Approving...',
        message: 'Please wait while we are approving the stake contract to process your tokens.',
        isLoading: true,
        txHash: '',
        error: ''
       });

       const amount = parseEther(stakeAmount);

        const tx = await tContract.approve(stakeAddress, amount);
        await tx.wait();

        setModalProps({
         title: 'Staking...',
         message: 'Please wait while your tokens are being staked.',
         isLoading: true,
         txHash: '',
         error: ''
        });

        const result = await sContract.stake(parseEther(stakeAmount));
        const receipt = await result.wait();

        setModalProps({
          title: 'Transaction Successful',
          message: 'Your transaction has been completed successfully.',
          isLoading: false,
          txHash: receipt.hash,
          error: ''
       });
    } catch (error) {
      setModalProps({
        title: 'Transaction Failed',
        message: 'There was an error processing your transaction.',
        isLoading: false,
        txHash: '',
        error: error.message,
     });
    }
  }


  const claim = async() => {
    try {
      setModalOpen(true);
      setModalProps({
        title: 'Claiming...',
        message: 'Please wait while we are processing your transaction.',
        isLoading: true,
        txHash: '',
        error: ''
       });

       const result = await sContract.withdraw();
       const receipt = await result.wait();
      
       setModalProps({
        title: 'Transaction Successful',
        message: 'Your transaction has been completed successfully.',
        isLoading: false,
        txHash: receipt.hash,
        error: ''
     });

    } catch (error) {
      setModalProps({
        title: 'Transaction Failed',
        message: 'There was an error processing your transaction.',
        isLoading: false,
        txHash: '',
        error: error.message,
     });
    }
  }

  const handleStakeAmountChange = (e) => {
    setStakeAmount(e.target.value);
  };


  const calculateClaimButtonTimeLeft = () => {
    const diff = nextWithdraw - new Date().getTime();
    if (diff > 0) {
      return {
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60)
      };
    }
    return { days: 0, hours: 0, minutes: 0, seconds: 0 };
  };

  const [claimButtonTime, setClaimButtonTime] = useState(calculateClaimButtonTimeLeft());

  useEffect(() => {
    const timer = setInterval(() => {
      setClaimButtonTime(calculateClaimButtonTimeLeft());
    }, 1000);
    return () => clearInterval(timer);
  }, [nextWithdraw]);

  return (
    <section className="toggle-section" id="stake">
      {/* Left Box con effetto stelle */}
      <div className="toggle-box">
        <div className="toggle-buttons">
          <button 
            className={`toggle-button ${selectedView === 'view1' ? 'active' : ''}`}
            onClick={() => setSelectedView('view1')}
          >
            <span>Stake</span>
          </button>
          <button 
            className={`toggle-button ${selectedView === 'view2' ? 'active' : ''}`}
            onClick={() => setSelectedView('view2')}
          >
            <span>Redeem</span>
          </button>
        </div>

        {/* Content Area */}
        <div className="toggle-content">
          {selectedView === 'view1' ? (
            <div className="stake">
              <h3>Stake your tokens and earn extra rewards</h3>
              <p className="orange-text">{ currentApy +"% Annual Percentage Yield"}</p>
              <input 
                type="number" 
                placeholder="Enter amount" 
                value={stakeAmount} 
                onChange={handleStakeAmountChange} 
                className="full-width-input" 
              />
              <button className="stake-button" onClick={stake}>Stake Now</button>
            </div>
          ) : (
            <div className="claim-view">
              <h2>Your rewards</h2>
              <div className="reward-grid">
                <div className="reward-square">
                  <span className="reward-title">Total Deposits</span>
                  <span className="reward-value">{deposits.length}</span>
                </div>
                <div className="reward-square">
                  <span className="reward-title">Total Staked</span>
                  <span className="reward-value">{totalStaked}</span>
                </div>
                <div className="reward-square">
                  <span className="reward-title">Redeemed Rewards</span>
                  <span className="reward-value">{claimedRewards}</span>
                </div>
                <div className="reward-square">
                  <span className="reward-title">Matured Rewards</span>
                  <span className="reward-value">{availableToClaim}</span>
                </div>
              </div>
              {/* Claim Button with Timer */}
              <button 
                onClick={claim}
                className="claim-button" 
                disabled={claimButtonTime.minutes !== 0 || claimButtonTime.seconds !== 0}
              >
                {claimButtonTime.minutes === 0 && claimButtonTime.seconds === 0
                  ? "Redeem now"
                  : `Redeem in ${claimButtonTime.days}d ${claimButtonTime.hours}h ${claimButtonTime.minutes}m ${claimButtonTime.seconds}s`}
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Right Image senza bordo e ombra superiore */}
      <div className="toggle-image">
        <img src={sampleImage} alt="Staking Rocket" />
      </div>

      <Modal
        isOpen={modalOpen}
        title={modalProps.title}
        message={modalProps.message}
        txHash={modalProps.txHash}
        error={modalProps.error}
        isLoading={modalProps.isLoading}
        onClose={closeModal}
      />
    </section>
  );
};

export default Staking;
